import React from 'react';
import styles from './Spinner.module.css';

const CustomSpinner = () => {
    return (
        <div className={styles.custom_spinner_container}>
            <div className={styles.custom_loading_spinner}></div>
        </div>
    );
};

export default CustomSpinner;
